import { render, staticRenderFns } from "./Authorised.vue?vue&type=template&id=2623ab77&scoped=true&"
import script from "./Authorised.vue?vue&type=script&lang=js&"
export * from "./Authorised.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2623ab77",
  null
  
)

export default component.exports